var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pause"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.14551 12.0163V2.68294C2.14551 2.36077 2.40667 2.09961 2.72884 2.09961H5.06217C5.38435 2.09961 5.64551 2.36077 5.64551 2.68294V12.0163C5.64551 12.3384 5.38435 12.5996 5.06217 12.5996H2.72884C2.40667 12.5996 2.14551 12.3384 2.14551 12.0163ZM8.56217 12.5996H10.8955C11.2177 12.5996 11.4788 12.3384 11.4788 12.0163V2.68294C11.4788 2.36077 11.2177 2.09961 10.8955 2.09961H8.56217C8.24 2.09961 7.97884 2.36077 7.97884 2.68294V12.0163C7.97884 12.3384 8.24 12.5996 8.56217 12.5996Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPause);
export default __webpack_public_path__ + "static/media/pause.0f2c76ea3cb0ef27af5176bc8f791de5.svg";
export { ForwardRef as ReactComponent };